export default __webpack_public_path__ + "static/media/Giverny.f26a7221.jpg";